import React from "react";
import PropTypes from "prop-types";

const ProviderLogo = function ({ logo, name, className, containerStyles, imageStyles }) {
  const getInitials = (name) => {
    const nameArray = name.split(" ");
    const initials = nameArray.map((name) => name.charAt(0)).join("");
    return initials;
  };

  if (!logo)
    return (
      <div
        className={`d-flex align-items-center justify-content-center text-white font-weight-bold font-b3 ${className} `}
        style={{ height: "50px", width: "50px", backgroundColor: "#808080", borderRadius: "5px", ...containerStyles }}
      >
        {getInitials(name)}
      </div>
    );
  return (
    <div
      className={`d-flex align-items-center justify-content-center ${className}`}
      style={{ height: "50px", width: "50px", ...containerStyles }}
    >
      <img
        src={logo}
        alt="alt"
        style={{ objectFit: "contain", width: "100%", height: "100%", borderRadius: "5px", ...imageStyles }}
      />
    </div>
  );
};

ProviderLogo.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  logo: PropTypes.string,
  containerStyles: PropTypes.shape({}),
  imageStyles: PropTypes.shape({}),
};

ProviderLogo.defaultProps = {
  name: "",
  className: "",
  logo: null,
  containerStyles: {},
  imageStyles: {},
};

export default ProviderLogo;
